// extracted by mini-css-extract-plugin
module.exports = {"gsapdGroupC":"groupcC_gsapdGroupC__MZzVz"};